import type { FaireProductEntity } from "../../entity_types/product";

export const p_b4xu75jqcr: FaireProductEntity = {
  token: "p_b4xu75jqcr",
  type: "product",
  name: "Dunkin' Donuts Cup - Food Print - New England Wall Art",
  brandToken: "b_2nlyab4cca",
  brandName: "Sarah Wormann Art",
  imageUrl: "https://cdn.faire.com/fastly/0613cd17b68af15e39f2504c189b0f05d8ce4ac77a8f5f939a891a2294ab1e60.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/97a3988cb2a15269fc33808ca62746de6d4d485ea9f7e3b054fc27488d4a358f.jpeg",
    "https://cdn.faire.com/fastly/5d616e0457eda5cae286ef4e7c80e669295fcc5a677c11c5c341716b216ddad0.jpeg",
    "https://cdn.faire.com/fastly/1f3bcc10404001aa71a8f287f2cee3215ae6dc24972b2b139296d21e0c4c534e.jpeg",
    "https://cdn.faire.com/fastly/284e07e643c79579bae684809dc61d7ecc04638247271fde9bae29de86c27780.jpeg"
  ],
  priceDollars: 10,
  description: "Fine art print of a cup of Dunkin' Donuts coffee, originally created with watercolor and ink.\n\nEach piece is painted, printed, and packaged by Sarah in her home studio in Boston, MA.\n\n𝐏𝐫𝐢𝐧𝐭 𝐝𝐞𝐭𝐚𝐢𝐥𝐬:\n• Printed on archival paper using pigment inks for crisp details and vibrant colors that will last years and years\n• Hand-signed in pencil\n\n𝐒𝐢𝐳𝐞𝐬:\n• Available sizes: 5”x7”\n• Print sizes fit standard frames\n\n𝐏𝐚𝐜𝐤𝐚𝐠𝐢𝐧𝐠 𝐚𝐧𝐝 𝐬𝐡𝐢𝐩𝐩𝐢𝐧𝐠:\n• Each print is packaged in a clear sleeve with cardboard backing, ready to display\n• Orders are shipped in a rigid mailer or cardboard box\n• All prints are unframed",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:13.577Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
